"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const service_processor_1 = require("./service.processor");
class BrowseProcessor extends service_processor_1.ServiceProcessor {
}
exports.BrowseProcessor = BrowseProcessor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJvd3NlLnByb2Nlc3Nvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9jZXNzb3JzL2Jyb3dzZS5wcm9jZXNzb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwyREFBdUQ7QUFFdkQsTUFBYSxlQUFnQixTQUFRLG9DQUFnQjtDQUFHO0FBQXhELDBDQUF3RCJ9